(function () {
  angular.module("akitabox.ui.dialogs.document.restore", [
    "akitabox.core.constants",
    "akitabox.core.services.document",
    "akitabox.core.toast",
  ]);
})();
